import React from "react";

const DeleteIcon = (props) => {
  const { width = "24", height = "24", color = "#181912" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M22.25 5.5H3M10.25 10.75v7M15.5 10.75v7M20.75 5.5v16.625a.875.875 0 0 1-.875.875h-14A.875.875 0 0 1 5 22.125V5.5M17.25 5.5V3.75A1.75 1.75 0 0 0 15.5 2h-5.25A1.75 1.75 0 0 0 8.5 3.75V5.5"
      />
    </svg>
  );
};

export default DeleteIcon;
